module.exports = __webpack_public_path__ + "static/envelope-33656dffb019abeda648060ac5d51444.svg";